import { useQuery } from "@apollo/client/react";
import { Box, Notification, P, StyledLink } from "orcs-design-system";

import { TEAM_TAB } from "src/consts/urlPaths";
import { teamDetailsPath } from "src/util/routing";

import InboxPaneLoading from "../InboxPaneLoading";
import type { ParsedInboxKey } from "../kinds";
import { inboxForecastTeamLookup } from "./lookup.graphql";
import type { ForecastTeam } from "./item";

type LookupQuery = {
  getGroup?: ForecastTeam | null;
};

const ForecastMissing = ({ parsed }: { parsed: ParsedInboxKey }) => {
  const lookup = useQuery<LookupQuery>(inboxForecastTeamLookup, {
    variables: { groupId: parsed.subjectId },
  });
  const teamPath = teamDetailsPath(parsed.subjectId, TEAM_TAB.DETAILS);
  if (lookup.loading) {
    return <InboxPaneLoading />;
  }
  if (lookup.error || lookup.dataState !== "complete") {
    return (
      <Box p="r">
        <Notification variant="error" closable={false}>
          This team could not be loaded.
        </Notification>
      </Box>
    );
  }
  const name = lookup.data.getGroup?.name?.trim() || "This team";
  return (
    <Box p="r">
      <Notification variant="warning" closable={false}>
        This team no longer needs a forecast from you.
      </Notification>
      {teamPath ? (
        <P m="0" mt="s">
          <StyledLink to={teamPath}>{name}</StyledLink>
        </P>
      ) : null}
    </Box>
  );
};

export default ForecastMissing;
